/** @jsx jsx */
/* eslint-disable no-use-before-define */
import { jsx } from '@emotion/core'
import { sectionCss } from '../style'

import React from 'react'
import { ContextProvider } from './use-market-news'
import Criteria from'./criteria'
import News from'./news/news'
import { subscribe, unsubscribe, getId } from '../../twd'

export default ({modal, ...props}) => {
    return <ContextProvider modal={modal}>
        <Main modal={modal} {...props} />
    </ContextProvider>
}

const Main = ({modal=false} = {}) => {

    const [available, setAvailable] = React.useState(true)
    React.useEffect(() => {
        let subId = subscribe('municipals-market-news-unavailable.municipals-market-news', (f) => {
            setAvailable(!f)
        })

        return () => {
            unsubscribe(subId)
        }
    }, [])

    let id = modal ? getId() : 'municipal-market-news'

    return <React.Fragment>
        <div id={id} className="vertical-offset-sm"></div>
        <div data-name="municipals-market-news" className={ modal ? '' : 'container vertical-offst-sm' } css={sectionCss}>
        <div className="row vertical-offset-sm"></div>

        { !modal && <div className="row">
        <div className="col-md-12 col-xs-12">
            <h3 className="medium-header">Municipal Market News</h3>
        </div>
        </div>}

        { available && <React.Fragment>
            <div className="row">
            <div className="col-md-12">
                <Criteria />
            </div></div>

            <div className="row vertical-offset-sm"></div>
            <News modal={modal} />
        </React.Fragment>}

        { !available && <React.Fragment>
            <div className="text-muted text-center">
                <i className="material-icons et-icon-lg" aria-hidden="true">chat</i>
                <br/>
                The Municipal Market News module is currently unavailable.
                <br/>
                Please try again at a later time.
            </div>
        </React.Fragment>}

        <div className={ modal ? 'row vertical-offset-xxs' : 'row vertical-offset-sm' }></div>
        </div>
    </React.Fragment>
}